export const shareList = [
  {
    url: 'https://t.me/share/url?url=',
    name: 'Telegram',
  },
  {
    url: 'https://api.whatsapp.com/send?text=',
    name: 'What’s App',
  },
  {
    url: 'http://vk.com/share.php?url=',
    name: 'VK',
  },
]
